export default __webpack_public_path__ + "static/media/val_conv_3.0eaeabea.png";